__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "dipf.theme";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("bootstrap", "5.3.3", () => (__webpack_require__.e(295).then(() => (() => (__webpack_require__(5295))))));
			register("jquery", "3.7.1", () => (__webpack_require__.e(278).then(() => (() => (__webpack_require__(8379))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(350), __webpack_require__.e(653)]).then(() => (() => (__webpack_require__(5350))))));
			register("react", "18.2.0", () => (__webpack_require__.e(902).then(() => (() => (__webpack_require__(1902))))));
			register("slick-carousel", "1.8.1", () => (Promise.all([__webpack_require__.e(34), __webpack_require__.e(630)]).then(() => (() => (__webpack_require__(1034))))));
			register("swr", "2.2.5", () => (Promise.all([__webpack_require__.e(134), __webpack_require__.e(653)]).then(() => (() => (__webpack_require__(5134))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};